export { default } from './ActivityLabel';
